/* global angular */

/**
 * Adds a button "Show more" if the element's height is more than the maxHeight
 */
angular
.module('gc.ui.showMore', [])
.directive('gcShowMore', [
'$rootScope',
'$compile',
'$sanitize',
'$filter',
'CommentService',
'Utils',
function ($rootScope, $compile, $sanitize, $filter, CommentService, Utils) {
  'use strict';

  var alreadyExpanded = [];

  return {
    link: function (scope, element) {
      var prevContent;
      scope.$watch('comment', function (comment) {

        // ignore if comment.content is same
        if (prevContent && prevContent === comment.content) return;

        // ignore if comment already expanded
        if (alreadyExpanded.indexOf(comment._id) !== -1) return;
        alreadyExpanded.push(comment._id);

        if (comment.parent_id) {
          var commentOpened = $rootScope.commentOpened;

          // ignore the comment opened using the bbf
          if (comment._id === commentOpened) return;

          // .. and all it's child comments
          if (commentOpened) {
            commentOpened = CommentService._comments[commentOpened];
            if (commentOpened) {
              var found = CommentService.recursiveFind(commentOpened, comment._id);
              if (found) return;
            }
          }
        }

        var txt = comment.content;
        prevContent = comment.content

        /*
        // deactivate for sub-comments
        if (Number(scope.depth) > 0) {
          var content = $filter('htmlContent')(txt);

          // Emoticons
          content = $filter('emoticonsFallback')(content);

          element
            .empty()
            .append(content);
          return;
        }
        */

        var full = $filter('htmlContent')(txt);
        full = $filter('emoticonsFallback')(full);

        var charLimit = 350;

        // length of a string without html tags,
        // because if we copy-paste text between browsers
        // they add a lot of html we don't want to take into account.
        function lengthWithoutHtml(str) {
          return $('<div></div>').html(str).text().length;
        }

        if (
          lengthWithoutHtml(txt) <= charLimit ||
          Utils.getParameterByName('comment_id') === comment._id // disable for yak.li links
        ) {
          element.empty().append(full);
          return;
        }

        var part1 = '<span ng-hide="comment.expanded" ng-click="comment.expanded = true">' + $filter('htmlContent')($filter('limitHtml')(txt, charLimit, ''))  + '</span>';
        var part2 = '<span class="full-content" ng-show="comment.expanded">' + $filter('htmlContent')(txt) + '</span>';

        // Emoticons

        part1 = $filter('emoticonsFallback')(part1);
        part2 = $filter('emoticonsFallback')(part2);

        var readmoreTemplate = '<span ng-hide="comment.expanded" ng-click="comment.expanded = true">...&nbsp;&nbsp;&nbsp;' +
          '<span class="gc-show-more"' +
          '      ng-mouseenter="expandAfter500ms()"' +
          '      ng-mouseleave="leaveExpand()">' +
          '  <span translate>readmore</span>' +
          '  <span class="gcicon-readmore"></span>' +
          '</span>' +
          '</span>';

        element.empty()
          .append($compile(part1)(scope))
          .append($compile(readmoreTemplate)(scope))
          .append($compile(part2)(scope));
      }, true);
    }
  };
}]);
